import type { FC, ReactNode } from 'react';
import ReactLoading from 'react-loading';

const Loading: FC<ReactNode> = () => (
  <ReactLoading type="spin" color="#087bf6" height={100} width={100} className="autocenter" />
);

export default Loading;
